import type { QueueWarning } from '@/api/cockpit';

export interface WarningsBannersProps {
  obstructive: readonly QueueWarning[];
  informative: readonly QueueWarning[];
  fallback: readonly string[];
}

export function WarningsBanners(props: WarningsBannersProps): JSX.Element | null {
  if (
    props.obstructive.length === 0 &&
    props.informative.length === 0 &&
    props.fallback.length === 0
  ) {
    return null;
  }
  return (
    <>
      {props.obstructive.length > 0 ? (
        <div className="rounded-md border border-destructive/40 bg-destructive/5 p-3 text-xs text-foreground">
          <div className="font-semibold text-destructive">Blocking Issues</div>
          <ul className="mt-1 list-disc space-y-1 pl-4">
            {props.obstructive.map((warning) => (
              <li key={warning.id}>{warning.message}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {props.informative.length > 0 ? (
        <div className="rounded-md border border-warning/40 bg-warning/10 p-3 text-xs text-warning-foreground">
          <div className="font-semibold">Informative Warnings</div>
          <ul className="mt-1 list-disc space-y-1 pl-4">
            {props.informative.map((warning) => (
              <li key={warning.id}>{warning.message}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {props.fallback.length > 0 ? (
        <div className="rounded-md border border-warning/40 bg-warning/10 p-3 text-xs text-warning-foreground">
          <div className="font-semibold">Warnings</div>
          <ul className="mt-1 list-disc space-y-1 pl-4">
            {props.fallback.map((warning) => (
              <li key={warning}>{warning}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </>
  );
}
